/**
 * Runtime-tunable constants for the frontend.
 *
 * Every value below is sourced from a REACT_APP_* env var at build/start time
 * (CRA bakes them into the bundle — see ../config.js note in plan). Defaults
 * are the historical literal values so behaviour is preserved if .env is silent.
 *
 * Pattern: `Number(process.env.X) || <default>` — guards against
 * Number(undefined) === NaN as well as Number('') === 0 when the env var
 * is unset; an explicit 0 override would also fall through to default, which
 * we consider acceptable for these positive-only limits.
 *
 * To change a value: edit project-root .env, restart the dev container with
 * --force-recreate (dev) or rebuild the prod image (prod).
 */

// File upload caps — must stay aligned with nginx client_max_body_size in
// frontend/nginx.conf (the upload location block must be >= MAX_FILE_SIZE_MB).
export const MAX_FILES = Number(process.env.REACT_APP_MAX_FILES) || 20;
export const MAX_FILE_SIZE_MB = Number(process.env.REACT_APP_MAX_FILE_SIZE_MB) || 16;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

// Query lifecycle — abort timer + poll behaviour for sendQuery/retryQuery
export const QUERY_TIMEOUT_MS = Number(process.env.REACT_APP_QUERY_TIMEOUT_MS) || 600000;          // 10 min abort
export const QUERY_POLL_TIMEOUT_MS = Number(process.env.REACT_APP_QUERY_POLL_TIMEOUT_MS) || 240000; // 4 min poll cap
export const QUERY_POLL_INTERVAL_MS = Number(process.env.REACT_APP_QUERY_POLL_INTERVAL_MS) || 1000;

// 429 retry for transient backend throttling (_fetchWithRetry)
export const FETCH_MAX_RETRIES = Number(process.env.REACT_APP_FETCH_MAX_RETRIES) || 3;
export const FETCH_RETRY_DELAY_MS = Number(process.env.REACT_APP_FETCH_RETRY_DELAY_MS) || 3000;

// Export-zip polling (exportGraphDirect default args)
export const EXPORT_POLL_MS = Number(process.env.REACT_APP_EXPORT_POLL_MS) || 2000;
export const EXPORT_MAX_POLL_MINUTES = Number(process.env.REACT_APP_EXPORT_MAX_POLL_MINUTES) || 30;
